import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  APP_INIT_ERROR, APP_READY, subscribe, initialize,
} from '@edx/frontend-platform';
import { AppProvider, ErrorPage } from '@edx/frontend-platform/react';

import App from './App';

import './index.scss';
import messages from './i18n';

const container = document.getElementById('root');
const root = createRoot(container!);

subscribe(APP_READY, () => {
  root.render(
    <AppProvider wrapWithRouter={false}>
      <App />
    </AppProvider>,
  );
});

subscribe(APP_INIT_ERROR, (error: any) => {
  root.render(<ErrorPage message={error.message} />);
});

initialize({
  messages,
  hydrateAuthenticatedUser: true,
});
